import { useRef, useState } from 'react';

export default function UploadScreen({ onUpload, loading }) {
  const [dragging, setDragging] = useState(false);
  const fileRef = useRef();

  function processFile(file) {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = e => onUpload(new Uint8Array(e.target.result), file.name);
    reader.readAsArrayBuffer(file);
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#0b0e14',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      fontFamily: "'DM Mono', monospace",
    }}>
      <div style={{
        background: '#f59e0b', borderRadius: 12,
        width: 56, height: 56, display: 'flex',
        alignItems: 'center', justifyContent: 'center', marginBottom: 20,
      }}>
        <span style={{ color: '#0f1117', fontWeight: 900, fontSize: 26 }}>W</span>
      </div>

      <div style={{ color: '#f59e0b', fontWeight: 800, fontSize: 20, letterSpacing: 4 }}>WHEELEY</div>
      <div style={{ color: '#4b5563', fontSize: 12, marginBottom: 48, marginTop: 6 }}>
        COD RECONCILIATION TRACKER
      </div>

      <div
        onClick={() => !loading && fileRef.current.click()}
        onDragOver={e => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={e => { e.preventDefault(); setDragging(false); processFile(e.dataTransfer.files[0]); }}
        style={{
          width: 420,
          border: `2px dashed ${dragging ? '#f59e0b' : '#2a2f3e'}`,
          borderRadius: 16, padding: '56px 40px',
          textAlign: 'center', cursor: loading ? 'wait' : 'pointer',
          background: dragging ? '#1c1400' : '#0f1117',
          transition: 'all .2s',
        }}
      >
        {loading ? (
          <>
            <div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div>
            <div style={{ color: '#f59e0b', fontWeight: 700, fontSize: 14 }}>Processing file...</div>
            <div style={{ color: '#4b5563', fontSize: 12, marginTop: 6 }}>Uploading to database</div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 40, marginBottom: 16 }}>📂</div>
            <div style={{ color: '#f3f4f6', fontWeight: 700, fontSize: 14, marginBottom: 8 }}>
              Drop your daily XLSX file here
            </div>
            <div style={{ color: '#4b5563', fontSize: 12 }}>or click to browse · .xlsx files only</div>
          </>
        )}
      </div>

      <input
        type="file"
        ref={fileRef}
        accept=".xlsx,.xls"
        onChange={e => processFile(e.target.files[0])}
        style={{ display: 'none' }}
      />

      <div style={{ color: '#374151', fontSize: 11, marginTop: 32, textAlign: 'center', lineHeight: 1.8 }}>
        Each upload creates a new daily snapshot.<br />
        Hub teams can submit cash details after each upload.
      </div>
    </div>
  );
}
